import { computed, unref } from 'vue'
import { t } from './lang/index.mjs'

/** 跨链/兑换进度条副文案：强调「快」，与 60s 倒计时解耦 */
export function useProcessBannerSub(sec, reverseLeft) {
  return computed(() => {
    if (unref(reverseLeft) === 0) return ''
    const s = Number(unref(sec)) || 0
    if (s < 12) return t('跨链加速中，多数订单 1 分钟内到账')
    if (s < 40) return t('正在写入目标链，通常很快完成')
    return t('即将到账，感谢稍候')
  })
}
